import { plural } from "@lingui/core/macro";

/*
helper to simplify the reference to lingui translation id across all the components
*/

export const formatGuests = (guests: number) => {
  return plural(guests, { one: "# Guest", other: "# Guests" });
};

export const formatCruisesPlural = (cruises: number) =>
  plural(cruises, {
    one: "# Cruise",
    other: "# Cruises",
    zero: ""
  });

export const formatAvailableCruisesPlural = (cruises: number) =>
  plural(cruises, {
    one: "# Available cruise",
    other: "# Available cruises",
    zero: ""
  });

export const formatBrochuresPlural = (brochures: number) =>
  plural(brochures, {
    one: "# Brochure",
    other: "# Brochures",
    zero: ""
  });
